<template>
  <f7-popup
    ref="popupEnviarEmail"
    class="popup-enviar-email"
    :opened="opened !== false"
    @popup:opened="onPopupOpened"
    @popup:closed="onPopupClosed"
    swipe-to-close
  >
    <f7-page>
      <f7-navbar>
        <f7-nav-left></f7-nav-left>
        <f7-nav-title style="color:yellow;">{{$t('common.enviar_email')}}</f7-nav-title>
        <f7-nav-right v-if="$refs.rformEnviarEmail && $refs.rformEnviarEmail.formData && $refs.rformEnviarEmail.formData.from">
          <f7-link @click="$refs.rformEnviarEmail.saveItem()">{{$t('common.enviar')}}</f7-link>
        </f7-nav-right>
      </f7-navbar>
      
      <!-- Info header específica de entidad -->
      <f7-card v-if="entityConfig.infoHeader" class="elevation-3 padding-vertical-half padding-right">
        <f7-card-header>
          {{ entityConfig.infoHeader }}
        </f7-card-header>
      </f7-card>
      
      <r-form 
        ref="rformEnviarEmail" 
        @save="onSaveEnviarEmail"
        :dbAdapter="null"
        classContent="full-height"
        :readonly="false"
        :hidePreloaderOnSave="false"
        :defaultData="{enlazarAdjuntos: true}"
      >
        <template v-slot:default="{ rform }">
          <f7-popover 
            style="width: 250px;"
            :closeByBackdropClick="false" 
            :backdrop="true" 
            closeOnEscape
            ref="popover"
          >
            <f7-navbar :title="$t('common.opciones_disponibles')">
              <f7-nav-right>
                <f7-link popover-close icon-f7="multiply"></f7-link>
              </f7-nav-right>
            </f7-navbar>
            <f7-list no-hairlines-md>
              <ul>
                <li 
                  v-for="(opcion,index) in opciones" 
                  :key="'select.opcion-'+index" 
                  class="popover_option" 
                  @click="opcion.action?ejecutarAction(opcion, rform.formData):setOptionClicked(index)" 
                  :value="opcion.value"
                >{{ opcion.name }}</li>
              </ul>
            </f7-list>
          </f7-popover>
          <f7-card>
            <f7-card-content>
              <f7-list>
                <ul>
                  <f7-row>
                    <!-- Checkbox de agrupar solo para pedidos -->
                    <f7-col width="100" medium="100" v-if="entityConfig.entityName === 'pedido'">
                      <r-input
                        floating-label
                        outline
                        :label="$t('common.agrupar_por_pedido')"
                        :form="rform"
                        :simple="true"
                        type="check"
                        name="agrupar"
                        :readonly="false"
                        :override-readonly="true"
                      ></r-input>
                    </f7-col>
                    <f7-col width="100" medium="100">
                      <div style="padding: 4px 10px;" 
                        @contextmenu.prevent="showOptions(
                          {
                            opciones: entityConfig.remitenteOpciones || [
                              {name:'Datos del usuario', value:'{{$.empleadoActual.email}}', valueName:'{{$.empleadoActual.nombre}}'},
                              {name:'Datos del Primer inspector', value:'{{$.expediente.inspector1.email}}', valueName:'{{$.expediente.inspector1.nombre}}'},
                              {name:'Datos del Empleado de contratación', value:'{{$.empleadoContratacion.email}}', valueName:'{{$.empleadoContratacion.nombre}}'},
                              {name:'Entrada manual', value:'',action:'entradaManualCampo',params:[['fromName','from']]},
                            ],
                            callback: (selected) => {$set(rform.formData, 'fromName', {name:selected.name,value: selected.valueName});$set(rform.formData, 'from', {name:selected.name,value: selected.value});}
                          }, 
                          $event, 
                          true
                        )">
                        <f7-block-title>{{$t('common.remitente')}}</f7-block-title>
                        <div class="block-chips">
                          <f7-chip 
                            v-if="rform.formData.from && rform.formData.fromName"
                            :text="rform.formData.fromName.name" 
                            :tooltip="rform.formData.fromName.value + ' - ' + rform.formData.from.value"
                            deleteable @delete="rform.formData.from = undefined;rform.formData.fromName = undefined"
                          ></f7-chip>
                        </div>
                      </div>
                    </f7-col>
                    <f7-col width="100" medium="100">
                      <div style="padding: 4px 10px;" 
                          @contextmenu.prevent="showOptions(
                            {
                              opciones: entityConfig.destinatarioOpciones || [
                                {name:'e-mail del contacto del cliente', value:'{{$.cliente.emailContacto}}'},
                                {name:'Entrada manual', value:'',action:'entradaManualLista',params:['to']},
                              ],
                              callback: (selected) => {
                                if(!rform.formData.to) {
                                  $set(rform.formData, 'to', []);
                                }
                                rform.formData.to.push(selected);
                              }
                            }, 
                            $event, 
                            true
                          )"
                        >
                        <f7-block-title>{{$t('common.destinatarios')}}</f7-block-title>
                        <div class="block-chips">
                          <f7-chip 
                            v-for="(chip, index) in rform.formData.to"
                            :key="'chip-to-'+index"
                            :text="chip.name" 
                            deleteable @delete="deleteChip($event, rform.formData.to, index)"
                          ></f7-chip>
                        </div>
                      </div>
                    </f7-col>
                    <f7-col width="100" medium="100">
                      <div style="padding: 4px 10px;" 
                        @contextmenu.prevent="showOptions(
                          {
                            opciones: entityConfig.ccOpciones || [
                              {name:'e-mail de tu usuario', value:'{{$.empleadoActual.email}}'},
                              {name:'e-Mail del Primer inspector', value:'{{$.expediente.inspector1.email}}'},
                              {name:'e-Mail del Empleado de contratación', value:'{{$.empleadoContratacion.email}}'},
                              {name:'Entrada manual', value:'',action:'entradaManualLista',params:['cc']},
                            ],
                            callback: (selected) => {
                              if(!rform.formData.cc) {
                                $set(rform.formData, 'cc', []);
                              }
                              rform.formData.cc.push(selected);
                            }
                          }, 
                          $event, 
                          true
                        )">
                        <f7-block-title>{{$t('common.en_copia')}}</f7-block-title>
                        <div class="block-chips">
                          <f7-chip 
                            v-for="(chip, index) in rform.formData.cc"
                            :key="'chip-cc-'+index"
                            :text="chip.name" 
                            deleteable @delete="deleteChip($event, rform.formData.cc, index)"
                          ></f7-chip>
                        </div>
                      </div>
                    </f7-col>
                    <f7-col width="100" medium="100">
                      <div style="padding: 4px 10px;" 
                        @contextmenu.prevent="showOptions(
                          {
                            opciones: entityConfig.ccoOpciones || [
                              {name:'e-mail del usuario', value:'{{$.empleadoActual.email}}'},
                              {name:'e-Mail del Primer inspector', value:'{{$.expediente.inspector1.email}}'},
                              {name:'e-Mail del Empleado de contratación', value:'{{$.empleadoContratacion.email}}'},
                              {name:'Entrada manual', value:'',action:'entradaManualLista',params:['cco']},
                            ],
                            callback: (selected) => {
                              if(!rform.formData.cco) {
                                $set(rform.formData, 'cco', []);
                              }
                              rform.formData.cco.push(selected);
                            }
                          }, 
                          $event, 
                          true
                        )">
                        <f7-block-title>{{$t('common.en_copia_oculta')}}</f7-block-title>
                        <div class="block-chips">
                          <f7-chip 
                            v-for="(chip, index) in rform.formData.cco"
                            :key="'chip-cco-'+index"
                            :text="chip.name" 
                            deleteable @delete="deleteChip($event, rform.formData.cco, index)"
                          ></f7-chip>
                        </div>
                      </div>
                    </f7-col>
                  </f7-row>
                </ul>
              </f7-list>
            </f7-card-content>
          </f7-card>
          <f7-card class="elevation-3 padding-vertical-half padding-right">
            <f7-card-content>
              <f7-list class="list-form">
                <ul>
                  <f7-row>
                    <f7-col width="100" medium="100">
                      <r-input
                        class="col-100 medium-25"
                        floating-label
                        :label="$t('common.plantilla_email')" 
                        :form="rform"
                        type="select"
                        name="plantillaEmail"
                        :clear-button="false"
                        @change="chargePlantillaEmail"
                      >
                        <option value="SIN">{{$t('common.sin_plantilla')}}</option>
                        <option 
                          v-for="plantilla in plantillas"
                          :value="plantilla.path"
                          :key="plantilla.path"
                        >{{plantilla.nombre}}</option>
                      </r-input>
                      
                      <div style="padding: 4px 10px;"
                        @contextmenu.prevent="showOptions(
                          {
                            opciones: entityConfig.asuntoOpciones || [
                              {name:'Envío de documentación', value:'Solicitud de documentación'},
                            ],
                            callback: (selected) => {
                              $set(rform.formData, 'asunto', selected.value);
                            }
                          },
                          $event,
                          true
                        )">
                        <r-input
                          class="col-100"
                          floating-label
                          outline
                          :label="$t('common.asunto')"
                          :form="rform"
                          name="asunto"
                        />
                      </div>
                      <r-rich-text-input
                        v-if="rform.formData.plantillaEmail"
                        style="overflow: hidden;"
                        ref="rRichTextInput"
                        class="col-100"
                        floating-label
                        :label="$t('common.cuerpo_email')"
                        :form="rform"
                        :name="'cuerpo'"
                      ></r-rich-text-input>
                    </f7-col>
                  </f7-row>
                </ul>
              </f7-list>
            </f7-card-content>
          </f7-card>
          <f7-card>
            <f7-card-content>
              <f7-list>
                <ul>
                  <f7-row>
                    <f7-col width="100" medium="100">
                      <r-files
                        class="col-100"
                        floating-label
                        outline
                        :label="$t('common.adjuntar_archivos')"
                        :form="rform"
                        name="attachments"
                      />
                    </f7-col>
                    <f7-col width="100" medium="100">
                      <div style="padding: 4px 10px;"
                        @contextmenu.prevent="showOptions(
                          {
                            opciones: entityConfig.documentosOpciones || [
                              {name:'Hoja de datos', value:'Hoja de datos'},
                            ],
                            callback: (selected) => {
                              if(!rform.formData.documentosAAdjuntar) {
                                $set(rform.formData, 'documentosAAdjuntar', []);
                              }
                              rform.formData.documentosAAdjuntar.push(selected.value);
                            }
                          }, 
                          $event, 
                          true
                        )">
                        <f7-block-title>{{$t('common.documentacion_a_adjuntar')}}</f7-block-title>
                        <div class="block-chips">
                          <f7-chip 
                            v-for="(chip, index) in rform.formData.documentosAAdjuntar"
                            :key="'chip-doc-'+index"
                            :text="chip" 
                            deleteable @delete="deleteChip($event, rform.formData.documentosAAdjuntar, index)"
                          ></f7-chip>
                        </div>
                      </div>
                    </f7-col>
                  </f7-row>
                </ul>
                <ul>
                  <f7-row>
                    <f7-col width="100" medium="100">
                      <r-input
                        floating-label
                        outline
                        :label="$t('common.enviar_como_enlaces')"
                        :form="rform"
                        :simple="true"
                        type="check"
                        name="enlazarAdjuntos"
                        :readonly="false"
                        :override-readonly="true"
                      ></r-input>
                    </f7-col>
                  </f7-row>
                </ul>
              </f7-list>
            </f7-card-content>
          </f7-card>
          <f7-row>
            <f7-col width="100" medium="100">
              <f7-button
                  fill
                  icon-f7="disk"
                  :text="$t('common.enviar')"
                  class="display-flex margin-vertical margin-left"
                  color="green"
                  @click="rform.saveItem()"
                ></f7-button>
            </f7-col>
          </f7-row>
        </template>
      </r-form>
    </f7-page>
  </f7-popup>
</template>
<style scoped>
  .popover_option {
    border-top: 1px solid #e0e0e0;
    padding: 5px;
    cursor: pointer;
  }
  .popover_option:hover {
    background-color: #707594;
    color:white;
  }
  .block-chips {
    display: flex;
    flex-wrap: wrap;
    background-color: #edecee;
    padding: 4px;
    border: 1px solid rgb(128, 128, 128);
    border-radius: 4px;
    min-height: 34px;
  }
</style>
<script>
import rFiles from "./rFiles.vue";
import rForm from "./rForm.vue";
import rInput from "./rInput.vue";
import rRichTextInput from "./rRichTextInput.vue";
import Utils from "../js/Utils.js";
import preloaderDeLaSesion from "../js/utils/preloaderDeLaSesion.js";
import Documento from "../js/db/Documento.js";
import DocumentoGestion from "../js/db/DocumentoGestion.js";

export default {
  components: {
    rForm,
    rInput,
    rRichTextInput,
    rFiles
  },
  data() {
    return {
      Documento,
      Utils,
      plantillas: [],
      contexto: {},
      opciones: false,
      popupOpened: false,
      translator: {
        "from": "email del remitente",
        "fromName": "nombre del remitente",
        "to": "email del destinatario",
        "cc": "email en copia",
        "cco": "email en copia oculta",
      }
    };
  },
  props: {
    opened: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Array,
      default: function() {
        return [];
      },
    },
    refName: {
      type: String,
      default: "popupEnviarEmail"
    },
    className: {
      type: String,
      default: "popup-enviar-email"
    },
    entityConfig: {
      type: Object,
      required: true,
      /*
      Estructura esperada:
      {
        entityName: 'tarea|pedido|oferta|oportunidad',
        dbAdapter: TareaAdapter, // El adaptador de base de datos correspondiente
        plantillaSuffix: '_tarea', // Sufijo para filtrar plantillas
        idField: 'id', // Campo ID para envío (opcional, por defecto 'id')
        infoHeader: 'Texto informativo específico de la entidad',
        destinatarioOpciones: [...], // Array de opciones para destinatarios
        ccOpciones: [...], // Array de opciones para CC
        ccoOpciones: [...], // Array de opciones para CCO
        asuntoOpciones: [...], // Array de opciones para asunto
        documentosOpciones: [...] // Array de opciones para documentos
      }
      */
    }
  },
  computed: {},
  methods: {
    ejecutar: function(action, params) {
      const self = this;
      self[action](...params);
    },
    ejecutarAction: function(opcion, formData) {
      const self = this;
      
      try {
        if (opcion.action === 'entradaManualLista') {
          // Para entradaManualLista, el primer parámetro es formData y el segundo el nombre del campo
          const targetField = opcion.params && opcion.params[0];
          if (targetField) {
            self.entradaManualLista(formData, targetField);
          }
        } else if (opcion.action) {
          if (typeof opcion.action === 'function') {
            // Si opcion.action es una función, la ejecutamos directamente con el contexto del componente padre
            opcion.action.call(self.$parent || self, opcion.params || []);
          } else if (typeof opcion.action === 'string') {
            // Si es un string, buscar el método por nombre
            if (self.$parent && typeof self.$parent[opcion.action] === 'function') {
              // Ejecutar la acción en el contexto del componente padre
              self.$parent[opcion.action](formData,opcion.params || []);
            } else if (typeof self[opcion.action] === 'function') {
              // Ejecutar la acción en el contexto actual
              self[opcion.action](formData,opcion.params || []);
            } else {
              // La acción no existe, mostrar advertencia pero no fallar
              console.warn(`Acción '${opcion.action}' no encontrada en el componente ni en el padre`);
              self.$f7.toast.create({
                text: `Acción '${opcion.action}' no disponible`,
                position: 'center',
                closeTimeout: 2000
              }).open();
            }
          } else {
            // La acción no existe, mostrar advertencia pero no fallar
            console.warn(`Acción '${opcion.action}' no encontrada en el componente ni en el padre`);
            self.$f7.toast.create({
              text: `Acción '${opcion.action}' no disponible`,
              position: 'center',
              closeTimeout: 2000
            }).open();
          }
        }
      } catch (error) {
        console.error(`Error ejecutando acción '${opcion.action}':`, error);
        self.$f7.toast.create({
          text: `Error ejecutando acción: ${error.message}`,
          position: 'center',
          closeTimeout: 3000
        }).open();
      } finally {
        // Cerrar el popover después de ejecutar la acción (o después del error)
        if (self.$refs.popover) {
          self.$refs.popover.close();
        }
      }
    },
    entradaManualLista: function(formData, targetFieldName) {
      const self = this;
      const app = self.$f7;
      if(!formData[targetFieldName]) {
        self.$set(formData, targetFieldName, []);
      }
      app.dialog.prompt(self.translator[targetFieldName], self.$t('common.entrada_manual'), (valor) => {
        formData[targetFieldName].push({name: valor, value: valor});
      });
    },
    entradaManualCampo: function(formData, targetFieldName) {
      const self = this;
      const app = self.$f7;
      if(targetFieldName instanceof Array) {
        targetFieldName.forEach(field => {
          app.dialog.prompt(self.translator[field], self.$t('common.entrada_manual'), (valor) => {
            self.$set(formData, field, {name: valor,value: valor});
          });
        });
      } else {
        app.dialog.prompt(self.translator[targetFieldName], self.$t('common.entrada_manual'), (valor) => {
          self.$set(formData, targetFieldName, [{name: valor, value: valor}]);
        });
      }
    },
    deleteChip: function(e, array, index) {
      const self = this;
      const app = self.$f7;
      const target = e.target;
      app.dialog.confirm(self.$t('common.eliminar_valor_lista'), () => {
        array.splice(index,1);
      });
    },
    showOptions: function(property, event, replace = true) {
      const self = this;
      const opciones = property.opciones;
      self.contexto.event = event;
      self.contexto.replace = replace;
      if(opciones && opciones.length) {
        self.opciones = opciones;
        self.contexto.property = property;
        self.$refs.popover.open(event.target);
      }
    },
    setOptionSelected: function(event) {
      const self = this;
      let optionSelected = self.opciones[event.target.options.selectedIndex];
      self.contexto.property.callback(optionSelected);
      self.$refs.popover.close(self.contexto.event.target);
      self.contexto = {};
    },
    setOptionClicked: function(index) {
      const self = this;
      let optionSelected = self.opciones[index];
      self.contexto.property.callback(optionSelected);
      self.$refs.popover.close(self.contexto.event.target);
      self.contexto = {};
    },
    recuperarPlantillas: function() {
      var self = this;
      var app = self.$f7;
      self.$refs.rformEnviarEmail.formData.plantillaEmail = "SIN";
      DocumentoGestion.getListaDocumentosPorTipo("EMAIL").then(data => {
        self.plantillas = data.list.filter(l => l.nombre.endsWith(self.entityConfig.plantillaSuffix));
      });
    },
    chargePlantillaEmail: function(e) {
      var self = this;
      var app = self.$f7;
      if(typeof e == 'object') {
        let formData = self.$refs.rformEnviarEmail.formData;
        if(self.$refs.rRichTextInput) self.$refs.rRichTextInput.setReadonly(false);
        if(!formData.plantillaEmail || formData.plantillaEmail == '') {
          self.$set(formData, "cuerpo", "");
        } else if(formData.plantillaEmail == 'SIN') {
          self.$set(formData, "cuerpo", "<html><body></body></html>");
        } else {
          Documento.getDocumento(formData.plantillaEmail).then(data => {
            const dec = new TextDecoder("utf-8");
            let html = dec.decode(data);
            if(self.$refs.rRichTextInput) self.$refs.rRichTextInput.setReadonly(true);
            self.$set(formData, "cuerpo", html);
          });
        }
      }
    },
    onSaveEnviarEmail (dataEnviar) {
      const self = this;
      const app = self.$f7;
      let data = [];
      // vamos a añadir los campos que le pasamos en selected al componente.

      
      // Si tenemos attachments, los procesamos para que el contenido del campo _base64 pase al nuevo campo base64
      if (dataEnviar.attachments) {
        dataEnviar.attachments.forEach(attachment => {
          if (attachment._base64) {
            attachment.base64 = attachment._base64;
          }
        });
      }
      
      // Preparar datos para cada elemento seleccionado
      let selectedItems = self.selected;
      
      // Si es pedido y le decimos que tiene que agrupar, trataremos las líneas para que tengan idPedido y numerosLinea
      if (self.entityConfig.entityName === 'pedido' && dataEnviar.agrupar) {
        let lineasAgrupadas = {};
        selectedItems.forEach(selected => {
          if (!lineasAgrupadas[selected.id]) {
            lineasAgrupadas[selected.id] = {id: selected.id, numerosLinea: []};
          }
          lineasAgrupadas[selected.id].numeroLinea = selected.numeroLinea;
          lineasAgrupadas[selected.id].numerosLinea = lineasAgrupadas[selected.id].numerosLinea.concat(selected.numerosLinea || selected.numeroLinea);
        });
        selectedItems = Object.values(lineasAgrupadas);
      }
      
      selectedItems.forEach(selected => {
        const emailData = {
          ...selected,
          fromName: dataEnviar.fromName.value,
          from: dataEnviar.from.value,
          to: dataEnviar.to ? dataEnviar.to.map(t => t.value.trim()) : [],
          cc: dataEnviar.cc ? dataEnviar.cc.map(t => t.value.trim()) : [],
          cco: dataEnviar.cco ? dataEnviar.cco.map(t => t.value.trim()) : [],
          asunto: dataEnviar.asunto,
          plantillaEmail: dataEnviar.plantillaEmail,
          cuerpo: dataEnviar.cuerpo,
          documentosAAdjuntar: dataEnviar.documentosAAdjuntar,
          attachments: dataEnviar.attachments,
          enlazarAdjuntos: dataEnviar.enlazarAdjuntos
        };
        
        // Añadir campos específicos según la entidad
        if (self.entityConfig.entityName === 'pedido') {
          emailData.idPedido = selected.id;
          emailData.numerosLinea = selected.numerosLinea;
        } else {
          // Añadir el ID específico según la configuración
          const idField = self.entityConfig.idField || 'id';
          const entityIdField = `id${self.entityConfig.entityName.charAt(0).toUpperCase() + self.entityConfig.entityName.slice(1)}`;
          emailData[entityIdField] = selected[idField];
        }
        
        data.push(emailData);
      });
      
      // #663 · Su propia espera, encendida al recibir `save` y antes de que `rForm` suelte la suya:
      // el indicador sigue puesto mientras se envía y lo apaga solo esta operación, también si la
      // sesión cambia en vuelo y la frontera calla el `then` de abajo.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      
      // Llamar al método enviarEmail del adaptador correspondiente
      self.entityConfig.dbAdapter.enviarEmail(data).then(res => {
        espera.cerrar();
        app.dialog.alert(self.$t('common.emails_enviados'));
        self.$refs.rformEnviarEmail.clear();
        if (self.$refs.popupEnviarEmail) {
          self.$refs.popupEnviarEmail.close();
        }
      }).catch(e => {
        if (typeof e == "string") {
          e = {
            message: e
          };
        }
        
        // Intentar obtener los errores desde e.error.errors
        let errorMessage = self.$t('common.error_enviando_emails') + ': ';
        
        if (e.error && e.error.errors && Array.isArray(e.error.errors)) {
          // Si existe e.error.errors, mostrar cada error en una línea
          errorMessage += '<br>' + e.error.errors.join('<br>');
        } else if (e.error && typeof e.error === 'string') {
          // Si e.error es un string
          errorMessage += e.error;
        } else if (e.message) {
          // Fallback a e.message
          // Si el texto del mensaje es "Unexpected end of JSON input" mostrar como error "El servidor no responde"
          if (e.message === "Unexpected end of JSON input") {
            errorMessage += self.$t('El servidor no responde');
          } else {
            errorMessage += e.message;
          }
        } else {
          // Si no hay ningún mensaje, mostrar error genérico
          errorMessage += self.$t('common.error_desconocido');
        }
        
        app.dialog.alert(errorMessage);
      }).then(_ => {
        espera.cerrar();
      });
    },
    onPopupOpened: function(e) {
      var self = this;
      var app = self.$f7;
      self.popupOpened = true;
      self.recuperarPlantillas();
    },
    onPopupClosed: function(e) {
      var self = this;
      var app = self.$f7;
      this.$emit('email-enviado', true);
    },
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
  }
};
</script>
